var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"cols":"12"}},[_c('p',{staticClass:"mb-2"},[_c('span',[_vm._v("Rapport sur les échouées.")])])]),_c('b-col',{attrs:{"cols":"12"}},[_c('apex-line-area-chart')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }